import { combineReducers } from "@reduxjs/toolkit";
import { sortReducer } from "./reducer/sortReducer";
import { seriesTreeReducer } from "./reducer/seriesTreeReducer";
import { searchParamsReducer } from "./slices/searchParamsSlice";
import { resultsReducer } from "./slices/resultsSlice";
import { contentReducer } from "./slices/contentSlice";
import { facetsReducer } from "./slices/facetsSlice";
import { configReducer } from "./slices/configSlice";
import { metaReducer } from "./slices/metaSlice";
import { productsOnSaleReducer } from "./slices/productsOnSaleSlice";
import { recommendationPlacementReducer } from "./slices/recommendationPlacementSlice";

export const srpReducer = combineReducers({
  meta: metaReducer,
  searchParams: searchParamsReducer,
  results: resultsReducer,
  content: contentReducer,
  facets: facetsReducer,
  config: configReducer,
  productsOnSale: productsOnSaleReducer,
  recommendationPlacement: recommendationPlacementReducer,
  sort: sortReducer,
  seriesTree: seriesTreeReducer,
});
